import { render, staticRenderFns } from "./ExpiredPicklsPopup.vue?vue&type=template&id=0b76d0a5&scoped=true&"
import script from "./ExpiredPicklsPopup.vue?vue&type=script&lang=ts&"
export * from "./ExpiredPicklsPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ExpiredPicklsPopup.vue?vue&type=style&index=0&id=0b76d0a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b76d0a5",
  null
  
)

export default component.exports